<div
  class="smart-org-container bg-white dark:bg-neutral-900 transition-all duration-500 overflow-hidden h-screen min-h-screen max-h-screen flex flex-col lg:flex-row"
>
  <!-- Mobile Header - Hidden on desktop and ai-agent routes -->
  @if (showMobileHeader) {
    <div class="flex-none lg:hidden w-full min-h-16 max-h-16">
      <app-mobile-header></app-mobile-header>
    </div>
  }

  <!-- Navbar - Hidden on mobile, visible on desktop -->
  <div class="hidden lg:block flex-none">
    <app-navbar [isAiAgentRoute]="isAiAgentRoute"></app-navbar>
  </div>

  <!-- Main Content -->
  <div class="flex-1 w-full h-full overflow-y-auto">
    <main class="smart-org-main w-full h-full">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Bottom Navigation Bar - Mobile Only -->
  <div
    class="bottom-bar flex-none lg:hidden w-full min-h-16 max-h-16 bg-neutral-800 backdrop-blur-sm border-t border-neutral-700/30 relative transition-all duration-200 z-40 flex items-center justify-center"
  >
    <div
      class="toggle-btn absolute -top-3 end-[10px] h-6 w-6 bg-neutral-700 rounded-md flex items-center justify-center text-neutral-300 transition-all duration-200 z-40"
      (click)="toggleBottomBar()"
    >
      <i class="fa-light fa-chevron-down text-xs"></i>
    </div>

    <nav
      class="flex items-center justify-around md:justify-center py-0 px-4 w-full max-w-full max-h-full space-x-2 md:space-x-4"
    >
      @for (item of navItems; track $index) {
        <div class="relative flex items-center justify-center">
          <button
            [disabled]="item.disable"
            (click)="!item.disable && navigateToRoute(item.route)"
            class="w-8 h-8 rounded-lg transition-all duration-200 min-w-0 flex items-center justify-center relative"
            [pTooltip]="(item.route === 'messenger' && shouldShowMessengerBadge) ? getMessengerTooltip() : (item.labelKey | transloco)"
            [tooltipOptions]="
              item.route === 'messenger'
                ? {
                    tooltipStyleClass: 'messenger-tooltip',
                    escape: false,
                  }
                : {}
            "
            [ngClass]="
              item.disable
                ? '!cursor-default opacity-50 text-neutral-500'
                : activeMenuItem.includes(item.route)
                  ? 'cursor-pointer text-primary-300 bg-primary-300/10'
                  : 'cursor-pointer text-neutral-300 hover:bg-neutral-700/80'
            "
            [attr.aria-label]="item.labelKey | transloco"
          >
            <i [class]="item.iconClass"></i>
            <!-- Badge for messenger item (mobile only) -->
            @if (item.route === 'messenger' && shouldShowMessengerBadge) {
              <span
                class="messenger-badge-mobile absolute -top-1 -right-1 min-w-[16px] h-[16px] flex items-center justify-center rounded-full text-[9px] font-semibold px-1 bg-rose-600 text-white"
              >
                {{ messengerUnreadMessages > 99 ? '99+' : messengerUnreadMessages }}
              </span>
            }
          </button>
        </div>
      }
      <!-- Apps Button -->
      <button
        [disabled]="false"
        (click)="toggleAppsDialog()"
        class="w-8 h-8 rounded-lg transition-all duration-200 cursor-pointer min-w-0 cursor-pointer text-neutral-300 hover:bg-neutral-700/80 flex items-center justify-center"
        [attr.aria-label]="'navbar.apps' | transloco"
      >
        <i class="pi pi-th-large"></i>
      </button>
    </nav>
  </div>
</div>
